<div [@scaleIn] *ngIf="visible" class="dialog">
    <h2 style="text-align: center;">Login as Sponsor</h2>
    <div class="form-group col-sm-12">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
        </div>
    </div>
    <form class="row" [formGroup]="sponsorLoginForm" (ngSubmit)="submit()">

        <div class="form-group col-sm-12">
            <label for="email">Email </label>
            <input type="text" class="form-control" formControlName="email" id="email" placeholder="email">
        </div>

        <div class="form-group col-sm-12">
            <label for="Password">Password</label>
            <input type="password" class="form-control" formControlName="password" id="password" placeholder="Password">
        </div>

        <div class="form-group col-sm-12">

            <div class="row d-flex justify-content-center" *ngIf="isLoading"> 
                <img class="loader" src="../../../assets/images/loader.gif" width="60px" alt="">
            </div>
            
            <div class="row">
                <div class="col-sm-6">
                    <button type="submit" (click)="submit()" class="btn btn-primary m-b-1">Login</button>
                </div>

                <div class="col-sm-6">
                    <button (click)="close()" class="btn btn-primary m-b-1 dialog__close-btn">Close</button>
                </div>
            </div>

        </div>
    </form>

    <hr color="white" class="rounded" size="8" width="100%">
    
    <div class="col-md-12 text-center">
        <button class="btn btn-primary btn-fb">
            <i class="fa fa-facebook-square prefix" aria-hidden="true"></i>
            Login With FaceBook
        </button>  
    </div>
    <div class="col-md-12 text-center m-t-1">
        <button class="btn btn-primary btn-google">
            <i class="fa fa-google-plus-square prefix" aria-hidden="true"></i>
            Login With Google
        </button>  
    </div>
</div>